import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xs leading-relaxed text-gray-500" }
const _hoisted_2 = ["href"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { commercialEmail, mailtoUrl, supportEmail } from '@/configs';
import PhoneQuotaReachedNotice from './PhoneQuotaReachedNotice.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyPhoneQuotaSummary',
  props: {
    used: {},
    limit: {},
    full: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

const label = computed(() =>
    props.limit === null
        ? t('whatsappMeta.quota.unlimited', { used: props.used })
        : t('whatsappMeta.quota.limited', { used: props.used, limit: props.limit }),
);
const requestIncreaseUrl = computed(() =>
    mailtoUrl(
        commercialEmail,
        supportEmail,
        t('whatsappMeta.quota.requestSubject'),
        t('whatsappMeta.quota.requestBody', { used: props.used, limit: props.limit ?? '-' }),
    ),
);

return (_ctx: any,_cache: any) => {
  const _component_UiBadge = _resolveComponent("UiBadge")!
  const _component_UiSettingsRow = _resolveComponent("UiSettingsRow")!
  const _component_UiSettingsSection = _resolveComponent("UiSettingsSection")!

  return (_openBlock(), _createBlock(_component_UiSettingsSection, {
    title: _unref(t)('whatsappMeta.quota.title'),
    footer: _unref(t)('whatsappMeta.quota.footer')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_UiSettingsRow, {
        title: _unref(t)('whatsappMeta.quota.rowTitle')
      }, {
        description: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.quota.rowDescription')) + " ", 1),
            _createElementVNode("a", {
              class: "text-primary font-medium underline",
              href: requestIncreaseUrl.value
            }, _toDisplayString(_unref(t)('whatsappMeta.quota.requestIncrease')), 9, _hoisted_2)
          ])
        ]),
        action: _withCtx(() => [
          _createVNode(_component_UiBadge, {
            variant: "gray-100",
            "text-variant": "gray-700",
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(label.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(PhoneQuotaReachedNotice, {
        full: _ctx.full,
        limit: _ctx.limit
      }, null, 8, ["full", "limit"])
    ]),
    _: 1
  }, 8, ["title", "footer"]))
}
}

})